import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const NEW_TEAM_LABEL_WIDTH = "90px";

export const useNewTeamFormStyles = makeStyles({
  noteText: {
    margin: 0,
    fontSize: designTokens.fontSize["2xs"],
    color: designTokens.neutral[500],
    lineHeight: designTokens.lineHeight.relaxed,
  },
  newTeamCard: {
    display: "flex",
    flexDirection: "column" as const,
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[4],
    padding: designTokens.spacing[4],
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid ${designTokens.neutral[200]}`,
  },
  newTeamRow: {
    display: "flex",
    gap: designTokens.spacing[4],
  },
  newTeamLabel: {
    flexShrink: 0,
    width: NEW_TEAM_LABEL_WIDTH,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[500],
    paddingTop: designTokens.spacing[1],
  },
  newTeamLabelWithInput: {
    paddingTop: "11px",
  },
  newTeamValue: {
    flex: 1,
    minWidth: 0,
  },
  newTeamValueText: {
    display: "block",
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
  },
  newTeamHint: {
    display: "block",
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    marginTop: designTokens.spacing[1],
  },
  newTeamHintRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[1],
    marginTop: designTokens.spacing[1],
  },
  newTeamHintText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
  },
  newTeamHintError: {
    color: designTokens.semantic.error,
  },
  resetButton: {
    color: projectIqTokens.teal,
    fontWeight: designTokens.fontWeight.semibold,
    padding: 0,
    ":hover": {
      color: projectIqTokens.teal,
    },
    ":hover:active": {
      color: projectIqTokens.teal,
    },
  },
  newTeamNameInputRoot: {
    width: "100%",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  newTeamNameInput: {
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]} ${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
  },
});
